// games.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_GAME_DATA,
  REMOVE_GAME_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Game.
 * @module reducer/games
 */
const games = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_GAME_DATA:
      return _MERGE_GAME_DATA(action.payload)(state);
    case REMOVE_GAME_DATA:
      return _REMOVE_GAME_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge game data
 * @kind reducer/actionType
 * @name MERGE_GAME_DATA
 * @param {array} {selectPath} - select path
 * @param {any} {data} - data
 * @return {Immutable.Map} New state
 */
const _MERGE_GAME_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Remove game data
 * @kind reducer/actionType
 * @name REMOVE_GAME_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_GAME_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default games;
